<template>
  <div class="createPermission">
    <!-- Create form start -->
    <el-row>
      <el-col :span="4">
        {{ $t("admin.role") }}:
        <h2>{{ editForm.name }}</h2>
      </el-col>
      <el-col :span="6" style="float: right">
        <el-input
          :placeholder="$t('common.search')"
          v-model="searchValue"
        ></el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
          ref="assignTable"
          @selection-change="handleSelectionChange"
          v-loading="loading"
          :data="searchResult"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="name"
            :label="$t('admin.name')"
          ></el-table-column>
          <el-table-column
            prop="surname"
            :label="$t('admin.surname')"
          ></el-table-column>
          <el-table-column
            prop="email"
            :label="$t('admin.email')"
          ></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button
          style="float: right; margin: 20px"
          type="primary"
          @click="updateRoles()"
          >{{ $t("admin.assign") }}</el-button
        >
      </el-col>
    </el-row>
    <!-- Create form Finish -->
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Admin",
  props: ["permission", "showAssignForm"],
  events: ["assigned"],
  components: {},
  data() {
    return {
      results: {},
      formLoading: false,
      createFormLoading: false,
      editFormLoading: false,
      showForm: false,
      showEditForm: false,
      editId: "",
      searchType: "name",
      searchValue: "",
      editForm: {},
    };
  },
  created() {
    this.editForm = JSON.parse(JSON.stringify(this.permission));
  },
  mounted() {
    this.checkAssignUser();
  },
  watch: {
    showAssignForm() {
      this.checkAssignUser();
    },
    permission() {
      this.editForm = JSON.parse(JSON.stringify(this.permission));
    },
    searchResult() {
      this.checkAssignUser();
    },
  },
  computed: {
    ...mapState("admin", ["roles", "users", "loading"]),
    searchResult() {
      return this.users.filter(
        (data) =>
          !this.searchValue ||
          data.name.toLowerCase().includes(this.searchValue.toLowerCase()) ||
          data.surname.toLowerCase().includes(this.searchValue.toLowerCase()) ||
          data.email.toLowerCase().includes(this.searchValue.toLowerCase())
      );
    },
  },
  methods: {
    ...mapActions("admin", ["updateRole"]),
    handleSelectionChange(val) {
      this.editForm.user = val.map((x) => x._id);
    },
    checkAssignUser() {
      this.$refs.assignTable.clearSelection();
      setTimeout(
        () =>
          this.users
            .filter((x) => this.permission.user.includes(x._id))
            .forEach((x) => {
              this.$refs.assignTable.toggleRowSelection(x);
            }),
        1
      );
    },
    sanitize(name) {
      this.editForm.name = name
        .trim()
        .toUpperCase()
        .replace(/[^a-zA-Z _]/g, "");
    },
    updateRoles() {
      this.editFormLoading = true;
      this.updateRole(this.editForm)
        .then(() => {
          this.editFormLoading = false;
          this.showEditForm = false;
        })
        .catch((e) => {
          console.log(e);
          return e;
        })
        .then((e) => {
          if (!e) this.$emit("assigned");
        })
        .finally(() => (this.editFormLoading = false));
    },
  },
};
</script>
<style scoped>
.el-dialog__body {
  padding: 20px 20px !important;
}
.createPermission {
  flex: 1;
  padding: 20px;
}
p {
  margin-left: 30px;
}
.el-form-item__content label.country-selector__label {
  line-height: normal;
}

.el-form-item__content label.input-tel__label {
  line-height: normal;
}
</style>
<style scoped>
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}

.tabs {
  flex-basis: 80%;
  display: flex;
}
.component {
  padding: 10px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
}
.component-container {
  margin: 0 10px 20px 10px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  min-width: 300px;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  flex: 1 0 48%;
}
</style>